import React from "react";
import PageShell from "@/components/PageShell";
import { ShieldCheck } from "lucide-react";

const TERMS = [
  "الجلسات المستعجلة تُجدَّل خلال أيام العمل فقط (لا تشمل الجمعة والسبت).",
  "جميع الجلسات تتم عبر Botim.",
  "تأجيل الجلسة بعد الجدولة قد يؤدي إلى تأخير الموعد حسب المتاح.",
  "التأخر في الرد لأكثر من عشر دقائق يؤدي إلى إعادة جدولة الموعد.",
  "يحق للأستاذة تأجيل الموعد لظروف خاصة مع إعادة الجدولة حسب الحجوزات.",
  "بمجرد بدء الجلسة تُعدّ مستهلكة بالكامل، ولا يتم تعويض الوقت غير المستخدم إذا تم الإنهاء من قبل العميل.",
  "يتم تعويض الوقت المتبقي فقط في حال إنهاء الجلسة من قبل المدرِّبة.",
  "يُمنع نشر أو مشاركة الكتاب أو الحصول عليه من مصادر غير الحسابات الرسمية، تفادياً للمساءلة القانونية.",
];

const Terms = () => (
  <PageShell>
    <section className="max-w-3xl mx-auto px-6 lg:px-12 py-16">
      <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full bg-[#F6F4EE] border border-[#E5E1D8] text-[#0A4D3C] text-sm">
        <ShieldCheck className="w-4 h-4" /> الشروط والتعليمات
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#222222] mt-6">الشروط والتعليمات</h1>
      <p className="text-[#5E5C58] mt-4 leading-loose">
        قبل إتمام أي حجز على منصة أوتادك، يُرجى الاطلاع على التعليمات التالية والموافقة عليها.
      </p>

      <ol
        data-testid="terms-list"
        className="mt-10 space-y-4 list-decimal ps-6 text-[#222222] leading-loose"
      >
        {TERMS.map((t, i) => (
          <li key={i} data-testid={`term-item-${i + 1}`} className="text-base">
            {t}
          </li>
        ))}
      </ol>
    </section>
  </PageShell>
);

export default Terms;
